import React, { useState } from "react";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import Whychooseus from "../../Components/internal-pages/WhyChooseus";
import { Helmet } from "react-helmet";

const GiftingReports =()=>{
    const [viewMore, setViewMore]= useState();
    const handleViewMore =()=>{
        setViewMore(prev=> !prev);
      }

    const CTAContent = [
        {
          pageName: "eYantra Gifting Report 2024",
          paragraphitalic: "",
          paragraphText:
            (
                <>
                    <p>
                        There are a number of occasions – birthdays, work anniversaries, and other significant business occasions where corporate giftings are required. Giving gifts as a way to show appreciation is crucial for developing strong business ties and encouraging employee involvement. While the budget may be up to you; the requirement of corporate gifting isn’t. According to Global Information the market for corporate gifts has expanded significantly in recent years. By 2024, it is expected to have grown to $839.57 billion (approx. Rs. 69.68 lakh crore) from $765.46 billion (approx. Rs. 63.33 lakh crore) in 2023, with a 9.7% compound annual growth rate (CAGR)  
                    </p>
                    {viewMore && (
                        <p>
                        The expansion throughout this time may be attributed to various causes, including the development of business relationships, recognition and appreciation campaigns, branding and marketing tactics, occasion-based gifting, and the pursuit of a competitive advantage. This significance of eYantra in influencing these corporate gifting strategies is emphasized in this report, which explores the present and potential trends. It offers a thorough industry study, points out new trends, and talks about how corporate gifting fits into business strategy. Strategic advice for utilizing corporate gifting to improve employee morale, brand loyalty, and overall business success are included in the report’s conclusion. 
                        </p>
                    )}
                    <p onClick={handleViewMore} style={{cursor:"pointer"}} className="text-black fw-bold  py-2">
                    {viewMore ? 'Read Less' : 'Read More'}
                    </p>                    
                </>
            ),
          ContactFormName: "Diwali Catalog",
        },
      ];

      


    return(
        <>
        <Helmet>
          <title>eYantra Gifting Report & Solutions</title>
          <meta name="description" content="Discover eYantra’s gifting report featuring employee gifts, corporate gifting trends, joining kits, and onboarding solutions across Hyderabad."/>
          <meta name="keywords" content="eyantra, gifting report, corporate gifting, joining kits, rewards and recognitions, onboarding kits for employees, corporate gifts for employees, welcome kits, employee gifts, corporate gifts in hyderabad"/>
        </Helmet>
        <div className="p-0 m-2">
            <Ctapage data={CTAContent}/>
            </div>
            <Whychooseus/>

        </>
    )
}

export default GiftingReports